import Pusher from 'pusher-js'

Pusher.logToConsole = process.env.NODE_ENV === 'development'

const pusherKey = process.env.VUE_APP_PUSHER_KEY
const pusherCluster = process.env.VUE_APP_PUSHER_CLUSTER || 'us2'

if (!pusherKey) {
  console.error('VUE_APP_PUSHER_KEY not configured')
}

const pusher = new Pusher(pusherKey || '', {
  cluster: pusherCluster,
  forceTLS: true
})

export default pusher
